module.exports = __webpack_public_path__ + "static/img/major_pictgrid6_800x728.03af610.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/major_pictgrid6_800x728.jpg
// module id = ICXm
// module chunks = 0